var $73f77c9902e29ca6$exports = {};
$73f77c9902e29ca6$exports = {
    "alpha": `Alfa`,
    "blue": `Azul`,
    "brightness": `Brilho`,
    "green": `Verde`,
    "hue": `Matiz`,
    "lightness": `Luminosidade`,
    "red": `Vermelho`,
    "saturation": `Satura\xe7\xe3o`
};


export {$73f77c9902e29ca6$exports as default};
//# sourceMappingURL=pt-BR.module.js.map
